import { defineExperiment } from '@cian/experiments/ab';
import { NEWBUILDING_PURCHASE_GIFT_EXPERIMENT } from 'shared/services/abUseExperiments/experiments';

/**
 * Эксперимент акции «30 000 ₽ за покупку квартиры»: A — контроль, B — точки входа показаны.
 */
export const NewbuildingPurchaseGiftExperiment = defineExperiment(NEWBUILDING_PURCHASE_GIFT_EXPERIMENT, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
